exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".-Wyv0{font-size:12px;z-index:10;position:relative}.iAO0X{padding:20px 15px}.rorEY{overflow-y:auto;max-height:100vh;margin:0 auto}._2nzt2{position:relative;border-radius:10px;max-width:330px}._2s_UK,.nugq9{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}.nugq9:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"titleLeasingLink": "-Wyv0",
	"rootModalLeasing": "iAO0X",
	"rootModal": "rorEY",
	"modal": "_2nzt2",
	"closeBtnIcon": "_2s_UK",
	"closeBtn": "nugq9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/LeasingOnlineBanner/LeasingModal/LeasingModal.css
// module id = 3195
// module chunks = 21